export default "__VITE_ASSET__pvjRWqdV__"